module.exports = __webpack_public_path__ + "static/media/intro.ea1ad66d.mp3";